import $ from "jquery";
import Matrix from "./matrix";
import util from "../util";
import {updateRuler} from "./page-ruler";
import {getPageGuides, getPagePanel, refreshPagePanel, refreshPagePanelMoveLinks} from "./page-panel";
import {rulerIsToggled, toggleRuler} from "./page-ruler";
import constants from "../constants";
import Text from "./text";
import MenuObject from "./menu-object";
import History from "./history";
import tippy from "tippy.js";
import store from "../store";
import * as actions from "../actions";
import {afterZoomReposition, setZoom} from "./zoom";
import {setLineHeights} from "./line-height";
import {moveLayoutGuidesInDom, setLayoutGuides} from "./layout-guides";
import Interactable from "./interactable";

let SIZE = null;

export function getSize() {
  return SIZE;
}

export function updatePageSize() {
  const dims = util.getActiveDimensions();
  $('.page').each(function () {
    const $this = $(this);
    $this.attr('data-size', dims.key);
    $this.attr('data-ratio', dims.ratio);
    $this.css('width', dims.width);
    $this.css('fontSize', dims.fontSize);
    $this.css('height', dims.height);
    if (dims.isCircular) $this.addClass('circular');
    else $this.removeClass('circular');
  });

  Matrix.refresh();
}

export function setPageSize(size) {
  function set() {
    SIZE = size;
    util.setPageDimensions(size);
    updatePageSize();
    updateRuler();
    refreshPagePanel();

    if (constants.SCALED_ZOOM_APPROACH) {
      afterZoomReposition();
    }
  }

  function redo() {
    set(size)
  }

  redo();
}

export function copyPage($page) {
  if ($('[data-component="page"]').length >= constants.maxDesignPages) return;
  const $pages = $('#pages');
  const $clone = $page.clone();

  $clone.attr('id', `page-${$pages.children().length + 1}`);
  $clone.find('[id]:not(#svgWrap)').each(function () {
    const newId = util.UUID.get();
    const $this = $(this);
    if ($this.parent().is('defs')) {
      const svgObj = $this.closest('svg').find('[fill]');
      svgObj.attr('fill', `url(#${newId})`);
    }
    $this.attr('id', newId);
  });

  function redo() {
    $pages.append($clone);
    $clone.find('[data-component="text"]').each(function () {
      const $this = $(this);
      Text.initQuill($this);
      setLineHeights($this);
    });

    $clone.find('.menu-object').each(function () {
      const $this = $(this);
      $this.find('.item[data-id]').each(function () { 
        const $this1 = $(this);

        const dataSource = $this1.attr('data-source');
        const isToast = dataSource === 'toast';
        const isSquare = dataSource === 'square';
        const isPopmenu = dataSource === 'popmenu';
        const isTreez = dataSource === 'treez';
        const isItemLibrary = dataSource === 'itemlibrary';
        const isPos = isToast || isSquare || isTreez || isPopmenu || isItemLibrary;

        if (!isPos) {
          const oldId = $this1.attr('data-id');
          const newId = util.UUID.get();
          $this1.attr('data-id', newId);
          const oldConfig = $this.find('.config').text();
          const newConfig = oldConfig.replaceAll(oldId, newId);
          $this.find('.config').text(newConfig);
        }
      });
      MenuObject.refreshStyles($this);
    });

    refreshPagePanel();
    refreshPageIds();
    if ($('[data-component="page"]').length >= constants.maxDesignPages) { 
      disableNewPages();
    }

    if (store.getState().isMobileVersion) {
      scrollToNewPage($clone);
    }
    if (store.getState().view === 'print') {
      store.dispatch(actions.setView('text'));
    }
  }

  function undo() {
    $clone.remove();
    refreshPagePanel();
    refreshPageIds();
    afterZoomReposition();
  }

  redo();
  History.push(undo, redo, 'Copy page');
}

export function movePage($page, direction) {
  function undo() {
    const pageId = $page.attr('id');
    const $pages = $('.page');

    for (let i = 0; i < $pages.length; i++) {
      const $page = $pages.eq(i);
      if ($page.attr('id') === pageId) {
        if (direction === 'up') {
          $pages.eq(i + 1).after($page);
        } else {
          $pages.eq(i - 1).before($page);
        }
        break;
      }
    }

    refreshPageIds();
    refreshPagePanelMoveLinks();
  }

  function redo() {
    const pageId = $page.attr('id');
    const $pages = $('.page');

    for (let i = 0; i < $pages.length; i++) {
      const $page = $pages.eq(i);
      if ($page.attr('id') === pageId) {
        if (direction === 'up') {
          $pages.eq(i - 1).before($page);
        } else {
          $pages.eq(i + 1).after($page);
        }
        break;
      }
    }

    refreshPageIds();
    util.bringInViewport($page);
    refreshPagePanelMoveLinks();
    if (store.getState().view === 'print') {
      store.dispatch(actions.setView('text'));
    }
  }

  redo();
  History.push(undo, redo, 'Move page' + direction);
}

export function removePage($page) {
  const $parent = $page.parent();
  const $prev = $page.prev();

  function undo() {
    if ($prev.length === 0) {
      $parent.prepend($page);
    } else {
      $prev.after($page);
    }

    refreshPagePanel();
    refreshPageIds();
    afterZoomReposition();
  }

  function redo() {
    $page.remove();
    refreshPagePanel();
    refreshPageIds();
    if ($('[data-component="page"]').length < constants.maxDesignPages) { 
      enableNewPages();
    }
    if (store.getState().view === 'print') {
      store.dispatch(actions.setView('text'));
    }

    const size = store.getState().designSize;
    if ((util.isTakeout(size) || util.isFoldedMenu(size) || util.isTableTent(size) || util.isSandwichBoard(size)) && util.getNumberOfPages() === 1) {
      $('.add-page-wrap').removeClass('hidden');
    }
  }

  redo();
  History.push(undo, redo, 'Remove page');
}

export function refreshPageIds() {
  const $pages = $('.page');
  for (let i = 0; i < $pages.length; i++) {
    const $page = $pages.eq(i);
    $page.attr('id', `page-${i + 1}`);
  }

  moveLayoutGuidesInDom();
  Interactable.refreshPageNumber();
}

export function addPage() {
  if ($('[data-component="page"]').length >= constants.maxDesignPages) return;
  const $pages = $('#pages');
  const dims = util.getActiveDimensions();
  const count = $pages.children().length + 1;

  const $first = $('.page:first');
  const firstBg = $first.css('background');
  const dataColor = $first.attr('data-color') || '';

  const content = `${'<div '
  + `id="page-${count}" class="page ${dims.isCircular ? 'circular' : ''}" `
  + 'data-component="page"'
  + ` data-ratio="${dims.ratio}" `
  + ` data-size="${dims.key}" `
  + ` data-color='${dataColor}' `
  + 'style="position: relative; '
  + `background: ${firstBg || '#FFF'}; `
  + `font-size: ${dims.fontSize}px; `
  + `width: ${dims.width}px; `
  + `height: ${dims.height}px;"> `
  + '<div class="content" style="overflow: hidden; position: relative; width: 100%; height: 100%;"></div>'}${
    getPageGuides()
  }${store.getState().isMobileVersion ? '' : getPagePanel()}</div>`;

  const $page = $(content);

  const $frame = $first.find('[data-component="frame"][data-full-page]');
  if ($frame.length > 0) {
    const $clone = $frame.clone();
    $clone.attr('id', util.UUID.get());
    $page.find('.content').append($clone);
  }

  function undo() {
    $page.remove();
    refreshPagePanel();
    refreshPageIds();
    afterZoomReposition();
  }

  function redo() {
    $pages.append($page);
    $page.find('.tippy').each(function () {
      tippy.one(this)
    });
    refreshPagePanel();
    refreshPageIds();

    const {layoutGuide, layoutGuidePageMargin, layoutGuideColumnMargin} = store.getState();
    setLayoutGuides(layoutGuide, layoutGuidePageMargin, layoutGuideColumnMargin);

    if (rulerIsToggled()) {
      toggleRuler();
      toggleRuler();
    }
    if ($('[data-component="page"]').length >= constants.maxDesignPages) { 
      disableNewPages();
    }
    if (store.getState().isMobileVersion) {
      scrollToNewPage($page);
    }
    initPageBars();
    if (store.getState().view === 'print') {
      store.dispatch(actions.setView('text'));
    }
  }

  redo();
  History.push(undo, redo, 'Add page');
}

function scrollToNewPage(page) {
  if (!((window.outerWidth / window.innerWidth) > 1)) {
    $("html, body").animate({ scrollLeft: page.offset().left }, () => {
      util.nextTick(() => {
        Interactable.deselectAll();
      }, 10);
    });
  }
}

export function getPagesContent() {
  $('.advisor-marker').each((index, element) => {
    $(element).remove();
  });

  return $('#pages').html();
}

export function disableNewPages() {
  $('#add-page').attr('data-hint', `You've reached the ${constants.maxDesignPages} page maximum for this design.`);
  $('#add-page').addClass('disabled-add-page');
  $('.copy-page').attr('data-hint', `You've reached the ${constants.maxDesignPages} page maximum for this design.`);
  $('.copy-page').addClass('disabled-copy-page');
}

function enableNewPages() {
  $('#add-page').attr('data-hint', '');
  $('#add-page').removeClass('disabled-add-page');
  $('.copy-page').attr('data-hint', 'Copy page');
  $('.copy-page').removeClass('disabled-copy-page');
}

export function initPageBars() {
  $('.page').each(function() {
    const $this = $(this);
    if ($this.find('.page-bars').length > 0) {
      return;
    }
    
    $this.find('.panel').after(`<div class="page-bars"></div>`);
  })
}
